import * as React from 'react';
import { Card, CardBody } from '../Card';
import { skeletonStyle as style } from './style';
import { useTheme } from '../Theme/Theme';
export const Skeleton = (props) => {
    const { isLoading, render = () => React.createElement("div", null) } = props;
    if (isLoading) {
        const theme = useTheme();
        return (React.createElement(Card, null,
            React.createElement(CardBody, null,
                React.createElement("div", { className: style(theme) },
                    React.createElement("div", { className: "skeleton" },
                        React.createElement("div", { className: "skeleton-content" },
                            React.createElement("div", { className: "skeleton-header" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '60%' } })),
                            React.createElement("div", { className: "skeleton-text" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '90%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '100%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '35%' } })),
                            React.createElement("div", { className: "skeleton-header" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '60%' } })),
                            React.createElement("div", { className: "skeleton-text" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '90%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '100%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '35%' } })),
                            React.createElement("div", { className: "skeleton-header" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '60%' } })),
                            React.createElement("div", { className: "skeleton-text" },
                                React.createElement("div", { className: "skeleton-line", style: { width: '90%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '100%' } }),
                                React.createElement("div", { className: "skeleton-line", style: { width: '35%' } }))))))));
    }
    return render && render();
};
//# sourceMappingURL=Skeleton.js.map